import Header from 'components/others/Header';
import RequireAuthRoute from 'components/others/RequireAuthRoute';
import StartSessionBlocker from 'components/others/StartSessionBlocker';
import {Navigate} from 'react-router';
import {Outlet as RouterOutlet} from 'react-router-dom';

import MenuTabBar from 'views/Menu/components/MenuTabBar';
import {MENU_ROUTE_BASE_PATHS} from 'utils/menuAvailability';
import {isWebClient} from 'utils/buildMode';

export default [
	...(!isWebClient ? [{
		path: '/outlet/:locationId',
		element: 'views/Auth/SaveLocationId',
	}] : []),
	...(!isWebClient ? [{
		path: '/admin',
		element: 'views/Auth/Login',
	}] : []),
	{
		path: '/auth',
		element: 'views/Auth/Login',
	},
	...(isWebClient ? [{
		path: `${MENU_ROUTE_BASE_PATHS.HANGRY_APP}/*`,
		element: <Navigate
			to={MENU_ROUTE_BASE_PATHS.RAYQUAZA}
			replace />,
	}] : []),
	{
		path: '/',
		element: (
			<RequireAuthRoute>
				<Header />
				{isWebClient ? <RouterOutlet /> : (
					<StartSessionBlocker>
						<RouterOutlet />
					</StartSessionBlocker>
				)}
			</RequireAuthRoute>
		),
		children: [
			{path: '/', element: 'views/Orders'},
			{path: '/outlet-status', element: 'views/OutletOnOff'},
			{
				path: '/menu',
				element: <MenuTabBar />,
				children: [
					{path: '/menu', element: 'views/Menu/MainMenu'},
					{path: '/menu/complex', element: 'views/Menu/ComplexMenu'},
					{path: '/menu/material', element: 'views/Menu/Material'},
					{path: '/menu/request-status', element: 'views/Menu/RequestStatus'},
					{path: '/menu/request-status/complex', element: <Navigate
						to='/menu/request-status'
						state={{focusToComplexTab: true}} />},
					...(!isWebClient ? [
						{path: `${MENU_ROUTE_BASE_PATHS.HANGRY_APP}`, element: 'views/Menu/MainMenu'},
						{path: `${MENU_ROUTE_BASE_PATHS.HANGRY_APP}/complex`, element: 'views/Menu/ComplexMenu'},
						{path: `${MENU_ROUTE_BASE_PATHS.HANGRY_APP}/material`, element: 'views/Menu/Material'},
						{path: `${MENU_ROUTE_BASE_PATHS.HANGRY_APP}/request-status`, element: 'views/Menu/RequestStatus'},
						{path: `${MENU_ROUTE_BASE_PATHS.HANGRY_APP}/request-status/complex`, element: <Navigate
							to={`${MENU_ROUTE_BASE_PATHS.HANGRY_APP}/request-status`}
							state={{focusToComplexTab: true}} />},
					] : []),
				],
			},
			{
				path: '/recon',
				children: [
					{path: '/recon', element: 'views/Reconciliation/ReconciliationSummary'},
					{path: '/recon/details', element: 'views/Reconciliation/ReconciliationDetails'},
				],
			},
			...(!isWebClient ? [{
				path: '/pos',
				element: 'views/POS',
			}] : []),
			...(!isWebClient ? [{
				path: '/settings',
				element: 'views/Settings',
			}] : []),
			...(!isWebClient ? [{
				path: '/shift',
				children: [
					{path: '/shift/start', element: 'views/Shift/StartDay'},
					{path: '/shift/end', element: 'views/Shift/EndDay'},
					{path: '/shift/history', element: 'views/Shift/ShiftHistory'},
					{path: '/shift', element: 'views/Shift'},
				],
			}] : []),
		],
	},
	{redirect: true},
];
